import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M1687.84 451.764H219.606V282.353C219.606 250.729 244.453 225.882 276.077 225.882H445.489V282.353C445.489 313.976 470.336 338.823 501.959 338.823C533.583 338.823 558.43 313.976 558.43 282.353V225.882H1349.02V282.353C1349.02 313.976 1373.87 338.823 1405.49 338.823C1437.11 338.823 1461.96 313.976 1461.96 282.353V225.882H1631.37C1662.99 225.882 1687.84 250.729 1687.84 282.353V451.764ZM1384.84 1069.8C1379.98 1054.2 1366.17 1043.69 1350.46 1043.69H1078.45L994.423 772.837V772.785C989.504 757.177 975.7 746.667 959.989 746.667C944.328 746.667 930.474 757.177 925.605 772.837L841.527 1043.69H569.517C553.806 1043.69 540.002 1054.2 535.133 1069.8C530.264 1085.41 535.485 1102.44 548.235 1112.16L768.342 1279.59L684.265 1550.49C679.396 1566.15 684.767 1583.18 697.516 1592.79C703.841 1597.58 711.27 1599.99 718.699 1599.99C726.128 1599.99 733.557 1597.58 739.932 1592.74L959.989 1425.37L1180 1592.74C1192.7 1602.41 1209.81 1602.41 1222.51 1592.79C1235.26 1583.18 1240.58 1566.15 1235.71 1550.44L1151.64 1279.59L1371.79 1112.16C1384.49 1102.44 1389.76 1085.41 1384.84 1069.8M1631.37 112.941H1461.96V56.4706C1461.96 24.8471 1437.11 0 1405.49 0C1373.87 0 1349.02 24.8471 1349.02 56.4706V112.941H558.431V56.4706C558.431 24.8471 533.584 0 501.961 0C470.337 0 445.49 24.8471 445.49 56.4706V112.941H276.079C182.337 112.941 106.667 188.612 106.667 282.353V1920H1800.78V282.353C1800.78 188.612 1725.11 112.941 1631.37 112.941V112.941Z",
  fillRule: "evenodd"
});

var IconImportantDatesSolid = /*#__PURE__*/function (_Component) {
  _inherits(IconImportantDatesSolid, _Component);

  var _super = _createSuper(IconImportantDatesSolid);

  function IconImportantDatesSolid() {
    _classCallCheck(this, IconImportantDatesSolid);

    return _super.apply(this, arguments);
  }

  _createClass(IconImportantDatesSolid, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconImportantDates",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconImportantDatesSolid.displayName = "IconImportantDatesSolid";
  return IconImportantDatesSolid;
}(Component);

IconImportantDatesSolid.glyphName = 'important-dates';
IconImportantDatesSolid.variant = 'Solid';
IconImportantDatesSolid.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconImportantDatesSolid;
export { IconImportantDatesSolid };